import { ref } from 'vue';
import { replaceSymbols } from '~packages/epk-front-shared/lib';
import { Item } from '~packages/epk-front-shared/src/ui/InputDatalist/InputDatalist.vue';

import IntegrationsApiService from '@/api/client/services/IntegrationsApiService';

const prevQuery = ref<string>('');

const fetchAddressData = async (query: string, isStartAddress: boolean) => {
  const integrationsApiService = new IntegrationsApiService();

  const res = isStartAddress
    ? await integrationsApiService.getFIASByStartAddress(query)
    : await integrationsApiService.getFIASByAddress(query);

  const data = res?.response?.[1]?.data;
  const meta = res?.response?.[1]?.meta;

  if (!data) return [];

  const addrIdx = meta.findIndex((item: Item) =>
    item.name.includes('FINAL_ADDR')
  );

  return data.map((item: string[]) => ({ name: item[addrIdx] }));
};

export const fetchItems = async (query: string, errors: { v: string }) => {
  const regex = /[a-zA-Zа-яёА-ЯЁ0-9]/g;

  const matches = query.match(regex);

  if (!matches || matches.length < 4) return [];

  if (errors) query = errors.v;

  query = replaceSymbols(query, ' ', '%25');

  if (prevQuery.value !== query) {
    prevQuery.value = query;
    return await fetchAddressData(query, false);
  }

  return [];
};

export const fetchItemsSelected = async (item: Item) => {
  if (item?.name.length < 4) return [];
  return await fetchAddressData(item.name, true);
};
